module.exports = __webpack_public_path__ + "img/div6-1.482dba04.jpg";